import createAction from 'utils/createAction'
import { CLOSE_SNACKBAR, SHOW, REMOVE, SHOW_MESSAGE } from './constants'

export const closeSnackbar = () => createAction(CLOSE_SNACKBAR)
export const show = args => createAction(SHOW, { ...args })
export const remove = (...args) => createAction(REMOVE, ...args)
